module.exports = __webpack_public_path__ + "img/jeanna-sig.6bf1090b.png";